import React from "react";

import Button from "@mui/material/Button";

export const SubmitButton = ({ children }: { children: React.JSX.Element }) => (
  <Button type="submit" variant="contained" color="secondary" sx={{ textTransform: "uppercase", mt: 2 }} fullWidth>
    {children}
  </Button>
);
